import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'btn-cell-renderer',
    template: 
		`<em>
			<div class="info-btn" *ngIf="enableEdit">
			<i class="fas fa-pencil custom-icon"  (click)="btnClickedHandler($event,'edit')"></i>      
			<i class="fas fa-trash-alt custom-icon" (click)="btnClickedHandler($event,'delete')"></i>    
			</div>
		</em>`
    ,
	styles: [`
        .info-btn{
            display: flex;
            gap: 0.8rem;
            color: #fff;
            cursor: pointer;
        }

		::ng-deep .custom-icon {
			/* background: linear-gradient(#000, rgb(49, 49, 49)); */
			border: 1px solid #676A6E;
			padding: 4px 4px 4px 4px;
			/* color: #fff; */
			cursor: pointer;
			background: transparent linear-gradient(180deg, #ffffff 0%, #e9f0f3 100%) 0% 0% no-repeat padding-box;
			opacity: 1;
			font: normal normal bold 10px;
			color: #676a6e;
		}
    `],
    standalone: false // NOSONAR
})
export class BtnCellRenderer implements ICellRendererAngularComp, OnDestroy {
	refresh(_params: ICellRendererParams): boolean {
		throw new Error("Method not implemented.");
	}

	private params: any;
	pageName;
	enableEdit: boolean = true;
	enableDelete: boolean = true;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		if (this.pageName == 'routes_action') { // NOSONAR
			this.enableEdit = false;
		}
	}

	btnClickedHandler(_event, action) {
		console.info("params", this.params);

		this.pageName = this.params.colDef.field;
		console.info("this is from", this.pageName);

		// console.info("Rate Id in btn cell renderer", this.params.data.rateId);
		//APR Cost
		if (action == 'delete' && this.pageName == 'aprrates_action') { // NOSONAR
			this.params.context.componentParent.deleteAprCostRow(this.params.data.rateId);
		}
		else if (action == 'edit' && this.pageName == 'aprrates_action') { // NOSONAR
			this.params.context.componentParent.editAprCostRow(this.params.data.rateId);
		}

		// Dummy Routes
		else if (action == 'delete' && this.pageName == 'routes_action') { // NOSONAR
			this.params.context.componentParent.deleteRow(this.params.data.dummyRouteID);
		}

		//Rail Points
		else if (action == 'delete' && this.pageName == 'railpoints_action') { // NOSONAR
			this.params.context.componentParent.deleteRailPointRow(this.params.data.railPointID);
		}
		else if (action == 'edit' && this.pageName == 'railpoints_action') { // NOSONAR
			this.params.context.componentParent.editRailPointRow(this.params.data.railPointID);
		}

		//Switch Points
		else if (action == 'delete' && this.pageName == 'switchpoints_action') { // NOSONAR
			this.params.context.componentParent.deleteSwitchPointRow(this.params.data.switchPointID);
		}
		else if (action == 'edit' && this.pageName == 'switchpoints_action') { // NOSONAR
			this.params.context.componentParent.editSwitchPointRow(this.params.data.switchPointID);
		}
	}

	ngOnDestroy() { // NOSONAR


	}
}
